import { useEffect, useState } from "react";
import FullScreenModal from "../../../components/FullScreenModal";
import { SubVideoList } from "./SubVideoList";
import { Banner } from "./Banner";
import { ConfirmDelete, ConfirmVideoDelete } from "./Confirmations";
import { Dialog } from "../../../components/Dialog";
import { api } from "../../../helpers/api";
import { PlaylistUpload } from "./PlaylistUpload";

export function PlayListDetail({ playlist, isOpen, onClose, refresh }) {
  const [deleteVideoPopupOpen, setDeleteVideoPopupOpen] = useState<any>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<any>(false);
  const [selectedPlaylist, setSelectedPlaylist] = useState<any>(null);
  const [isUploadOpen, setIsUploadOpen] = useState(false);

  const fetchData = () => {
    api.getPlaylistById(playlist?.playlist_id).then((res) => {
      setSelectedPlaylist(res?.data);
    });
  };

  useEffect(() => {
    fetchData();
  }, [refresh]);

  const handleAddCourses = () => {
    setIsUploadOpen(true);
  };

  return (
    <>
      <div className="fixed inset-0 flex bg-gray-900 bg-opacity-50 z-50 pt-12">
        <FullScreenModal isOpen={isOpen} onClose={onClose}>
          <div className=" max-w-[898px] mx-auto mt-[34px]">
            <Banner
              playlist={selectedPlaylist || playlist}
              onDelete={() => setIsDeleteModalOpen(true)}
            />

            <SubVideoList
              playlist={selectedPlaylist || playlist}
              onAdd={handleAddCourses}
              onDelete={(data) => setDeleteVideoPopupOpen(data)}
              onUpdate={() => {
                refresh();
                fetchData();
              }}
            />
          </div>
        </FullScreenModal>

        {deleteVideoPopupOpen && (
          <ConfirmVideoDelete
            playlist={selectedPlaylist || playlist}
            onClose={() => setDeleteVideoPopupOpen(false)}
            videoId={deleteVideoPopupOpen?.video_id}
            refetch={() => {
              refresh();
              setDeleteVideoPopupOpen(false);
              fetchData();
            }}
            name={deleteVideoPopupOpen?.video_title}
          />
        )}

        {isDeleteModalOpen && (
          <ConfirmDelete
            onClose={() => setIsDeleteModalOpen(false)}
            userId={playlist.playlist_id}
            refetch={() => {
              onClose();
              refresh();
            }}
            name={playlist.playlist_title}
          />
        )}

        {isUploadOpen && (
          <Dialog
            isOpen={true}
            onClose={() => setIsUploadOpen(false)}
            className="w-[80vw] max-w-[1400px]"
            title="Add Courses"
          >
            <PlaylistUpload
              loading={false}
              onBack={() => setIsUploadOpen(false)}
              onSubmit={async (selectedCourses) => {
                try {
                  const videoIds = selectedCourses.map(
                    (course) => course?.video_id
                  );
                  await api.updatePlaylist(playlist.playlist_id, {
                    video_ids: videoIds,
                  });
                  setIsUploadOpen(false);
                  refresh();
                  fetchData();
                } catch (error) {
                  console.error("Error updating playlist:", error);
                }
              }}
              initialSelectedCourses={selectedPlaylist?.videos || []}
            />
          </Dialog>
        )}
      </div>
    </>
  );
}
